import { DateTime } from 'luxon';

export const QUICK_DATE_FILTERS = [
  {
    label: 'Last week',
    getValue: () => ({
      start_date: DateTime.now().minus({ weeks: 1 }).startOf('week'),
      end_date:   DateTime.now().minus({ weeks: 1 }).endOf('week'),
    }),
  },
  {
    label: 'Last 2 weeks',
    getValue: () => ({
      start_date: DateTime.now().minus({ weeks: 2 }).startOf('week'),
      end_date:   DateTime.now().minus({ weeks: 1 }).endOf('week'),
    }),
  },
  {
    label: 'Last month',
    getValue: () => ({
      start_date: DateTime.now().minus({ months: 1 }).startOf('month'),
      end_date:   DateTime.now().minus({ months: 1 }).endOf('month'),
    }),
  },
  {
    label: 'This month',
    getValue: () => ({
      start_date: DateTime.now().startOf('month'),
      end_date:   DateTime.now().endOf('month'),
    }),
  },
  {
    label: 'Last 3 months',
    getValue: () => ({
      start_date: DateTime.now().minus({ months: 3 }).startOf('month'),
      end_date:   DateTime.now().minus({ months: 1 }).endOf('month'),
    }),
  },
];